import * as React from 'react';
const Eye = ({ fill = '#03488E', ...props }: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 22 16"
		fill="none"
		{...props}
	>
		<path
			fill={fill}
			d="M11 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0-4.5c5 0 9.27 3.11 11 7.5-1.73 4.39-6 7.5-11 7.5S1.73 12.39 0 8C1.73 3.61 6 .5 11 .5ZM2.18 8a9.821 9.821 0 0 0 17.64 0A9.821 9.821 0 0 0 2.18 8Z"
		/>
	</svg>
);
export default Eye;
